/**
 * Client-side fallback lists for `useCategories()` — used only when the server
 * returns zero entries for a category type (e.g. an environment an admin hasn't
 * seeded yet), so a picker never renders empty and blocks the form it belongs to.
 * Mirrors backend/src/seed/seed.ts's GLOBAL_CATEGORY_SEEDS exactly; keep both in
 * sync if either list changes. Real server data always takes priority over this.
 */

export const CROP_TYPE_FALLBACK = ['Lúa', 'Mít Thái', 'Sầu riêng', 'Cà phê', 'Bưởi da xanh', 'Thanh long', 'Rau màu'];

export const MATERIAL_GROUP_FALLBACK = ['Giống', 'Phân bón', 'Thuốc BVTV', 'Hóa chất', 'Bao bì', 'Công cụ'];

export const EXPENSE_CATEGORY_FALLBACK = ['Vật tư nông nghiệp', 'Nhân công', 'Vận chuyển', 'Chi phí khác'];

export const SOIL_TYPE_FALLBACK = ['Đất phù sa', 'Đất phèn', 'Đất mặn', 'Đất xám', 'Đất đỏ bazan', 'Đất cát', 'Đất thịt'];

export const LOAN_REJECT_REASON_FALLBACK = [
  'Không đủ điều kiện vay', 'eKYC chưa hoàn tất', 'Credit score không đạt', 'Risk profile nguy cơ cao',
  'Vượt hạn mức nông hộ', 'Vượt hạn mức HTX', 'Có nợ quá hạn', 'Hồ sơ không đầy đủ',
  'Phương án vay không khả thi', 'Nông hộ không còn hoạt động', 'Khác',
];

export const UNIT_OF_MEASURE_FALLBACK = ['kg', 'tấn', 'ha', 'công', 'sào', 'bao', 'thùng', 'lít'];

export const PROVINCE_FALLBACK = [
  'Hà Nội', 'TP. Hồ Chí Minh', 'Hải Phòng', 'Đà Nẵng', 'Cần Thơ',
  'An Giang', 'Bà Rịa - Vũng Tàu', 'Bạc Liêu', 'Bắc Giang', 'Bắc Kạn', 'Bắc Ninh', 'Bến Tre',
  'Bình Định', 'Bình Dương', 'Bình Phước', 'Bình Thuận', 'Cà Mau', 'Cao Bằng', 'Đắk Lắk', 'Đắk Nông',
  'Điện Biên', 'Đồng Nai', 'Đồng Tháp', 'Gia Lai', 'Hà Giang', 'Hà Nam', 'Hà Tĩnh', 'Hải Dương',
  'Hậu Giang', 'Hòa Bình', 'Hưng Yên', 'Khánh Hòa', 'Kiên Giang', 'Kon Tum', 'Lai Châu', 'Lâm Đồng',
  'Lạng Sơn', 'Lào Cai', 'Long An', 'Nam Định', 'Nghệ An', 'Ninh Bình', 'Ninh Thuận', 'Phú Thọ',
  'Phú Yên', 'Quảng Bình', 'Quảng Nam', 'Quảng Ngãi', 'Quảng Ninh', 'Quảng Trị', 'Sóc Trăng', 'Sơn La',
  'Tây Ninh', 'Thái Bình', 'Thái Nguyên', 'Thanh Hóa', 'Thừa Thiên Huế', 'Tiền Giang', 'Trà Vinh',
  'Tuyên Quang', 'Vĩnh Long', 'Vĩnh Phúc', 'Yên Bái',
];
